import { IIconProps, IconHeight, IconSizes, IconWidth } from '../Icons/type';

const UltraFresh: React.FC<IIconProps> = ({
  size = IconSizes.sm,
  UNSAFE_className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={IconWidth[size]}
    height={IconHeight[size]}
    className={UNSAFE_className || ''}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_2199_4317)">
      <path
        d="M8.59647 10.2711V2.31146C8.59647 1.4571 7.93257 0.770368 7.11826 0.770368C6.30394 0.770368 5.64004 1.46251 5.64004 2.31146V10.2711C4.95539 10.7632 4.50934 11.5797 4.50934 12.5097C4.50934 14.013 5.67635 15.2296 7.11826 15.2296C8.56017 15.2296 9.72718 14.013 9.72718 12.5097C9.72718 11.5797 9.27593 10.7632 8.59647 10.2711Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.38071 2.31146C5.38071 1.31319 6.16071 0.5 7.11826 0.5C8.07521 0.5 8.85581 1.30716 8.85581 2.31146V10.1338C9.53853 10.6799 9.98651 11.5377 9.98651 12.5097C9.98651 14.1623 8.70339 15.5 7.11826 15.5C5.53312 15.5 4.25 14.1623 4.25 12.5097C4.25 11.5385 4.69275 10.68 5.38071 10.1333V2.31146ZM7.11826 1.04074C6.44717 1.04074 5.89938 1.61183 5.89938 2.31146V10.2711C5.89938 10.36 5.85745 10.4432 5.78724 10.4937C5.16955 10.9376 4.76867 11.6726 4.76867 12.5097C4.76867 13.8637 5.81958 14.9593 7.11826 14.9593C8.41694 14.9593 9.46784 13.8637 9.46784 12.5097C9.46784 11.6735 9.06248 10.9378 8.44852 10.4931C8.37875 10.4426 8.33714 10.3597 8.33714 10.2711V2.31146C8.33714 1.60704 7.78994 1.04074 7.11826 1.04074Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.31743 9.16258C9.31743 9.01326 9.43354 8.89221 9.57676 8.89221H11.4907C11.6339 8.89221 11.75 9.01326 11.75 9.16258C11.75 9.3119 11.6339 9.43295 11.4907 9.43295H9.57676C9.43354 9.43295 9.31743 9.3119 9.31743 9.16258Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.31743 7.30786C9.31743 7.15854 9.43354 7.03749 9.57676 7.03749H11.2158C11.359 7.03749 11.4751 7.15854 11.4751 7.30786C11.4751 7.45718 11.359 7.57823 11.2158 7.57823H9.57676C9.43354 7.57823 9.31743 7.45718 9.31743 7.30786Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.31743 5.33417C9.31743 5.18485 9.43354 5.06381 9.57676 5.06381H10.7905C10.9337 5.06381 11.0498 5.18485 11.0498 5.33417C11.0498 5.48349 10.9337 5.60454 10.7905 5.60454H9.57676C9.43354 5.60454 9.31743 5.48349 9.31743 5.33417Z"
        fill="black"
      />
      <path
        d="M7.7666 10.5955L7.7251 6.76712C7.7251 6.39402 7.42946 6.09661 7.07158 6.09661C6.71369 6.09661 6.42842 6.39942 6.42842 6.77253V10.6334C5.80083 10.9416 5.27178 11.6986 5.27178 12.4665C5.27178 13.5317 6.09647 14.3915 7.11826 14.3915C8.14004 14.3915 8.96473 13.5263 8.96473 12.4665C8.96473 11.6932 8.39419 10.8983 7.7666 10.5901V10.5955Z"
        fill="#3C71DA"
      />
    </g>
    <defs>
      <clipPath id="clip0_2199_4317">
        <rect
          width="15"
          height="15"
          fill="white"
          transform="translate(0.5 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default UltraFresh;
